import Input from './input.vue'
export type { InputProps } from './props'
export default Input